<template>
  <BannerCard
    :icon="ContactBadgeIcon"
    :title="$t('plus_contact_badge')"
    :hint="$t('contact_badge_tooltip')"
    type="contact-badge"
    :withHint="true"
    :isActionable="true"
  >
    <template #cardData>
      <div class="tw:font-bold tw:text-sm tw:px-2 tw:py-1 tw:rounded tw:bg-green-200 tw:text-green-700">
        {{ $t('contact_badge_active') }}
      </div>
    </template>
    <template #dropdownMenu>
      <div class="tw:text-sm tw:hover:bg-blue-200 tw:hover:text-blue-800 tw:rounded-lg tw:flex">
        <router-link
          class="tw:hover:no-underline tw:px-4 tw:py-3 tw:w-full"
          :to="{ name: 'property-details-basic-information', query: { open_update: true } }"
          @click="logEvent"
        >
          {{ $t('go_prop_details_cta') }}
        </router-link>
      </div>
    </template>
  </BannerCard>
</template>
<script setup>
import BannerCard from '@/components/studioPlus/insights/BannerCard.vue'

import { selectedAccommodationId } from '@/layouts/queries'
import appAnalytics from '@/utils/tracking'

const ContactBadgeIcon = new URL('/src/assets/img/studio-plus-insights/contact-badge-icon.svg', import.meta.url)

const logEvent = () => {
  appAnalytics.track(appAnalytics.events.SP_PLUS_INSIGHTS_STATUS_INDICATOR_CLICKED, {
    item_id: selectedAccommodationId.value,
    menu_type: 'go_to_property_details',
  })
}
</script>
